<template>
</template>

<script>
    export default {
        props: {
            vodCourse: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                isAuth: false,
                user: {},
                isNewUser: false,
                isBusy: false,
                hasError: false,
                error: '',
                isSuccess: false,
            }
        },

        mounted() {
            // User logged in?
            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;
                    this.user = window.virtuoso.user;
                }
            }
            
            // When payment methods have been updated refresh that section
            Bus.$on("userRegistered", (d) => {
                this.isAuth = true;
                this.user = d;
                this.isNewUser = true;
                this.handlePreReg();
            });

            
            Bus.$on("fireVodPreRegister", (d) => {
                this.user = d;
                this.handlePreReg();
            });
        },

        methods: {
            // Register them
            handlePreReg() {
                Bus.$emit('vodPreRegisterBusy', true);
                axios.post('/api/vod_course/' + this.vodCourse.id + '/pre-register')
                    .then((response) => {
                        if(response.data.success) {
                            Bus.$emit('vodPreRegisterSuccess', response.data);
                        }

                        if(response.data.error) {
                            Bus.$emit('vodPreRegisterError', response.data.error);
                        }
                    })
                    .catch((error) => {
                        Bus.$emit('vodPreRegisterError', 'An unexpected error occured.');
                    });
            },
        }
    }
</script>